import { render, staticRenderFns } from "./order-basic.vue?vue&type=template&id=09172db0&scoped=true&"
import script from "./order-basic.vue?vue&type=script&lang=js&"
export * from "./order-basic.vue?vue&type=script&lang=js&"
import style0 from "./order-basic.vue?vue&type=style&index=0&id=09172db0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09172db0",
  null
  
)

export default component.exports